// Price-statistics pages and the product page each one belongs to. Also used by
// the footer, so every page links to the statistics pages in the static HTML.
const STATISTICS_PAGES = [
  {
    id: "go",
    link: "/statistics-go/",
    labelKey: "statisticsLinks.go",
    labelFallback: "Цени на Гражданска отговорност",
    productLink: "/grazhdanska-otgovornost-online/",
    productLabelKey: "statisticsLinks.goProduct",
    productLabelFallback: "Сравни цените на Гражданска отговорност"
  },
  {
    id: "kasko",
    link: "/statistics-kasko/",
    labelKey: "statisticsLinks.kasko",
    labelFallback: "Цени на Каско",
    productLink: "/kasko-kalkulator/",
    productLabelKey: "statisticsLinks.kaskoProduct",
    productLabelFallback: "Изчисли цената на Каско"
  },
  {
    id: "travel",
    link: "/statistics-travel/",
    labelKey: "statisticsLinks.travel",
    labelFallback: "Цени на застраховка за чужбина",
    productLink: "/zastrahovka-patuvane-v-chuzhbina/",
    productLabelKey: "statisticsLinks.travelProduct",
    productLabelFallback: "Сравни цените на застраховка за чужбина"
  }
];

module.exports = { STATISTICS_PAGES };
